// Collection page toolbar control: "Products per page" <select> navigates
// to an alternate view template (8 is the default template, 16/32/64 are
// `?view=per-N` templates — see templates/collection.per-*.json).
document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-per-page-select]');
  if (!select) return;
  window.location.href = select.value;
});
